import { Button, Tooltip } from '@mui/material';

const ApproveIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const RejectIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M15 5L5 15" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 5L15 15" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const actionStyles = {
	approve: {
		color: '#FFFFFF',
		border: '1px solid #00A63E',
		backgroundColor: '#00A63E',
		hoverBackgroundColor: '#039855',
		icon: <ApproveIcon />,
	},
	reject: {
		color: '#FFFFFF',
		border: '1px solid #E7000B',
		backgroundColor: '#E7000B',
		hoverBackgroundColor: '#D92D20',
		icon: <RejectIcon />,
	},
	activate: {
		color: '#FFFFFF',
		border: '1px solid #101828',
		backgroundColor: '#101828',
		hoverBackgroundColor: '#0F172A',
	},
	deactivate: {
		color: '#344054',
		border: '1px solid #D0D5DD',
		backgroundColor: '#FFFFFF',
		hoverBackgroundColor: '#F9FAFB',
		hoverBorderColor: '#98A2B3',
	},
};

const BulkStatusActionButton = ({ action, label, tooltip, onClick, disabled = false, sx = {} }) => {
	const config = actionStyles[action] || actionStyles.activate;

	const button = (
		<Button
			type="button"
			disabled={disabled}
			startIcon={config.icon}
			onClick={onClick}
			sx={{
				height: '36px',
				px: 2,
				gap: config.icon ? 0.75 : 0,
				borderRadius: '10px',
				fontSize: '14px',
				fontWeight: 500,
				lineHeight: '20px',
				textTransform: 'none',
				boxShadow: 'none',
				minWidth: 'auto',
				color: config.color,
				border: config.border,
				backgroundColor: config.backgroundColor,
				'& .MuiButton-startIcon': {
					margin: 0,
				},
				'&:hover': {
					boxShadow: 'none',
					backgroundColor: config.hoverBackgroundColor,
					borderColor: config.hoverBorderColor || config.border?.split(' ').at(-1),
				},
				...sx,
			}}
		>
			{label}
		</Button>
	);

	if (!tooltip) {
		return button;
	}

	return <Tooltip title={tooltip}>{button}</Tooltip>;
};

export default BulkStatusActionButton;
